// extracted by mini-css-extract-plugin
export default {"imageModel":"File_imageModel__DKZ3i","imagePlaceholder":"File_imagePlaceholder__DlM-l","imagePlaceholderIcon":"File_imagePlaceholderIcon__c7IQ+"};